import {
  HEALTH_CHALLENGES_BASE_ROUTE,
  HEALTH_CHALLENGES_SECURE_BASE_ROUTE,
  NEURODIVERSITY_BASE_ROUTE,
  NEURODIVERSITY_SECURE_BASE_ROUTE,
  WOMENS_HEALTH_BASE_ROUTE,
  WOMENS_HEALTH_SECURE_BASE_ROUTE,
} from '@lyrahealth-inc/shared-app-logic'

export function isPathInNeurodiversityFlow(pathname: string) {
  return pathname.startsWith(NEURODIVERSITY_BASE_ROUTE) || pathname.startsWith(NEURODIVERSITY_SECURE_BASE_ROUTE)
}

export function isPathInHealthChallengesFlow(pathname: string) {
  return pathname.startsWith(HEALTH_CHALLENGES_BASE_ROUTE) || pathname.startsWith(HEALTH_CHALLENGES_SECURE_BASE_ROUTE)
}

export function isPathInWomensHealthFlow(pathname: string) {
  return pathname.startsWith(WOMENS_HEALTH_BASE_ROUTE) || pathname.startsWith(WOMENS_HEALTH_SECURE_BASE_ROUTE)
}
